export const storeUser = data => {
    return {
        type: 'STORE_USER',
        user: data,
    }
}

export const removeUser = data => {
    return {
        type: 'REMOVE_USER',
    }
}

export default {
    storeUser,
    removeUser,
}
